import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from './messages';
import { TownsquareScope } from './types';
import getAtlasAggregatorRedirectUrl from './url-generators';
import getAtlasViewAllRedirectUrl from './url-generators';
var defaultTownsquareResultMapper = function defaultTownsquareResultMapper(_ref) {
  var results = _ref.results;
  return results.map(function (value) {
    return mapAggregatorResponseToSearchItem(value);
  }).slice(0, MAX_ITEMS_PER_SECTION);
};
export var MAX_ITEMS_PER_SECTION = 3;
var mapAggregatorResponseToSearchItem = function mapAggregatorResponseToSearchItem(response) {
  if ('account_id' in response) {
    return {
      title: response.name,
      id: response.account_id,
      meta: '',
      url: response.absoluteUrl || '',
      iconUrl: response.picture,
      containerId: '' // no container
    };
  } else {
    return {
      title: response.title,
      id: response.id,
      meta: '',
      url: response.url,
      iconUrl: response.iconUrl,
      containerId: '' // no container
    };
  }
};
export var getSections = function getSections(intl, workspaces, isGlobalExperienceWorkspace, orgId) {
  return [{
    id: TownsquareScope.TownsquareProject,
    title: intl.formatMessage(messages.townsquare_projects_heading),
    showResultCount: false,
    scope: TownsquareScope.TownsquareProject,
    resultMapper: defaultTownsquareResultMapper,
    viewAllLinkGenerator: function viewAllLinkGenerator(query) {
      return getAtlasViewAllRedirectUrl('projects', query, workspaces, isGlobalExperienceWorkspace, orgId);
    },
    viewAllLinkRenderer: function viewAllLinkRenderer() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.townsquare_projects_view_all);
    }
  }, {
    id: TownsquareScope.TownsquareGoal,
    title: intl.formatMessage(messages.townsquare_goals_heading),
    scope: TownsquareScope.TownsquareGoal,
    resultMapper: defaultTownsquareResultMapper,
    viewAllLinkGenerator: function viewAllLinkGenerator(query) {
      return getAtlasAggregatorRedirectUrl('goals', query, workspaces, isGlobalExperienceWorkspace, orgId);
    },
    viewAllLinkRenderer: function viewAllLinkRenderer() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.townsquare_goals_view_all);
    }
  }, {
    id: TownsquareScope.TownsquareHelpLink,
    title: intl.formatMessage(messages.townsquare_help_links_heading),
    scope: TownsquareScope.TownsquareHelpLink,
    resultMapper: defaultTownsquareResultMapper
  }, {
    id: TownsquareScope.TownsquareTag,
    title: intl.formatMessage(messages.townsquare_topics_heading),
    scope: TownsquareScope.TownsquareTag,
    resultMapper: defaultTownsquareResultMapper,
    viewAllLinkGenerator: function viewAllLinkGenerator(query) {
      return getAtlasAggregatorRedirectUrl('topics', query, workspaces, isGlobalExperienceWorkspace, orgId);
    },
    viewAllLinkRenderer: function viewAllLinkRenderer() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.townsquare_topics_view_all);
    }
  }, {
    id: TownsquareScope.TownsquareLearning,
    title: intl.formatMessage(messages.townsquare_learnings_risks_decisions_heading),
    scope: TownsquareScope.TownsquareLearning,
    resultMapper: defaultTownsquareResultMapper
  }];
};